{
  "CapabilitiesAffected": "Capabilities Affected:",
  "ShowRelated": "Show {relatedCount} Related"
} 
